import React, {memo} from 'react';

import {Box, TextField} from '@mui/material';

export const ParagraphTextConfig: React.FC = memo(() => {
  return (
    <Box marginBottom={5}>
      <TextField
        variant="outlined"
        multiline
        disabled
        fullWidth
        placeholder="Sua resposta"
      />
    </Box>
  );
});
